import React from "react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@coval/ui"

import { FieldLabel } from "@/components/shared/forms/FieldLabel"

import {
  CUSTOM_WEBSOCKET_PRESET,
  getActiveWebSocketPreset,
  JSON_AUDIO_PRESET,
  JSON_AUDIO_PRESET_METADATA,
  TWILIO_PRESET,
  TWILIO_PRESET_METADATA,
  WEBSOCKET_PRESET_RESET,
  type WebSocketConfigPreset,
} from "./presets"
import { type WebSocketFieldProps } from "./types"

export const WebSocketPresetSelect: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const activePreset = getActiveWebSocketPreset(metadata)

  const handlePresetChange = (preset: WebSocketConfigPreset) => {
    if (preset === JSON_AUDIO_PRESET) {
      onMetadataUpdate(JSON_AUDIO_PRESET_METADATA)
      return
    }
    if (preset === TWILIO_PRESET) {
      onMetadataUpdate(TWILIO_PRESET_METADATA)
      return
    }
    if (
      preset === CUSTOM_WEBSOCKET_PRESET &&
      activePreset !== CUSTOM_WEBSOCKET_PRESET
    ) {
      onMetadataUpdate(WEBSOCKET_PRESET_RESET)
    }
  }

  return (
    <div className="space-y-2">
      <FieldLabel
        htmlFor="websocket-config-preset"
        tooltip="Start from a JSON audio or Twilio Media Streams configuration, or choose Custom to configure the connection yourself."
      >
        Configuration Preset
      </FieldLabel>
      <Select
        value={activePreset}
        onValueChange={(value) =>
          handlePresetChange(value as WebSocketConfigPreset)
        }
        disabled={disabled}
      >
        <SelectTrigger
          id="websocket-config-preset"
          aria-label="Configuration Preset"
        >
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={CUSTOM_WEBSOCKET_PRESET}>Custom</SelectItem>
          <SelectItem value={JSON_AUDIO_PRESET}>JSON audio</SelectItem>
          <SelectItem value={TWILIO_PRESET}>Twilio Media Streams</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
